import axios from 'axios'
import React, { useEffect, useState, useCallback } from 'react'
import CustomTable from 'screens/CustomTable/CustomTable'
import { SectionsDataColumn } from './SectionsDataColumn'

import { useGlobalWebSocket } from 'context/WebSocketContext'
import { IconButton } from '@material-ui/core'
import { Edit } from '@material-ui/icons'
import SectionsAdd from './SectionsAdd'

import { useStoreon } from 'storeon/react'

const Sections = () => {
	const [tableData, setTableData] = useState([])
	const [loading, setLoading] = useState(true)
	const userId = localStorage.getItem('userId')
	const { token } = useStoreon('token')

	const fetchData = useCallback(async () => {
		setLoading(true)
		try {
			const response = await axios.get(
				`${process.env.REACT_APP_API_URL}/api/v1/custom/getSections`,
				{
					headers: {
						Authorization: ` ${token}`
					}
				}
			)
			setTableData(response.data)
		} catch (error) {
			console.error('Error fetching data:', error)
		} finally {
			setLoading(false)
		}
	}, [])

	useEffect(() => {
		fetchData()
	}, [fetchData])
	return (
		<div>
			<div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '10px' }}>
				<SectionsAdd onSuccess={fetchData} />
			</div>
			<CustomTable
				tableColumns={SectionsDataColumn(fetchData)}
				tableData={tableData}
				loading={loading}
				noDataMessage="No sections available"
			/>
		</div>
	)
}

export default Sections
